import stableStringify from 'fast-json-stable-stringify';

import type { ApiAddModificationIntent } from './shared';

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Scope exact proposed-action deduplication to one patient and one originating
 * clinician message. Any value-level difference in the complete action input
 * produces a different ID.
 */
export async function buildProposedActionExternalId(
  patientUserId: string,
  originatingUserMessageId: string,
  actionInput: ApiAddModificationIntent
): Promise<string> {
  const intent = stableStringify({
    patientUserId,
    originatingUserMessageId,
    actionInput,
  });
  const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(intent));
  return `copilot-${toHex(digest)}`;
}
